module.exports = {

  /**
   * write img element with error to track exceptions in kibana
   * @param key
   * @param message
   * @return {HTMLImageElement}
   */
  imgTrack(key,message) {
    let
      today = new Date(),
      date = today.getFullYear()+'_'+(today.getMonth()+1)+'_'+today.getDate(),
      time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
      dateTime = date+'-'+time,
      src = '/comun/img/dtm-track.jpg',
      querystring = encodeURI('key='+key+'&datetime='+dateTime+'&message='+message),
      img = document.createElement('img')
    ;
    img.src = src+'?'+querystring;
    return img;
  },
  exportRootVars() {
    for (let key in window.vocento.tracking.root) {
      if (vocento.tracking.root.hasOwnProperty(key)) {
        window[key] = vocento.tracking.root[key];
      }
    }
  },
  exportComscoreVars() {
    /** solo exportamos algunas variables, ya que VTM tiene prioridad sobre las vocvars y pisariamos sus valores */
    window.voc_ate    = window.vocento.tracking.comscore.voc_ate;
    window.voc_top    = window.vocento.tracking.comscore.voc_top;
    window.voc_site   = window.vocento.tracking.comscore.voc_site;
    window.voc_tcnew  = window.vocento.tracking.comscore.voc_tcnew;
    window.voc_tc     = window.vocento.tracking.comscore.voc_tc;
    window.voc_se     = window.vocento.tracking.comscore.voc_se;
    window.voc_au     = window.vocento.tracking.comscore.voc_au;
    window.voc_s1     = window.vocento.tracking.comscore.voc_s1;
    window.voc_s2     = window.vocento.tracking.comscore.voc_s2;
    window.voc_s3     = window.vocento.tracking.comscore.voc_s3;
    window.voc_s4     = window.vocento.tracking.comscore.voc_s4;
    window.voc_npc    = window.vocento.tracking.comscore.voc_npc;
  },
  setTrackBuscadorPlaySummum(TagManager){
    let main = window.document.getElementsByTagName('main');
    if (main.length >0 ) {
        let keywords = main[0].getAttribute('data-keywords');
        let num_entries = main[0].getAttribute('data-num-entries');
        let buscador = main[0].getAttribute('data-buscador');
        if (keywords !== null && keywords !== '') {
          TagManager.set({
            keyword: this.kebabCase(keywords),
            tipoBuscador: 'buscador-' + buscador,
            errorBusqueda: num_entries == 0 ? 'la-busqueda-no-obtuvo-ningun-resultado' : '',
            nResultados: num_entries
          });
        }
    }
  },
  kebabCase(string) {
    var result = string;
    // Convert camelCase capitals to kebab-case.
    result = result.replace(/([a-z][A-Z])/g, function(match) {
      return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
    });
    // Convert non-camelCase capitals to lowercase.
    result = result.toLowerCase();
    // Convert non-alphanumeric characters to hyphens
    result = result.replace(/[^-a-z0-9]+/g, '-');
    // Remove hyphens from both ends
    result = result.replace(/^-+/, '').replace(/-$/, '');
    return result;
  }
};



// WEBPACK FOOTER //
// ./src/tracking/trackUtils.js